
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle-emergency-response",
      function () {
        return require("private-next-pages/vehicle-emergency-response/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle-emergency-response"])
      });
    }
  